import { render, staticRenderFns } from "./QuelpTicketCard.vue?vue&type=template&id=52719808&scoped=true"
import script from "./QuelpTicketCard.vue?vue&type=script&lang=js"
export * from "./QuelpTicketCard.vue?vue&type=script&lang=js"
import style0 from "./QuelpTicketCard.vue?vue&type=style&index=0&id=52719808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52719808",
  null
  
)

export default component.exports